import MultiSelectMultiMenu from './MultiSelectMultiMenu';

export default MultiSelectMultiMenu;
